import { BaseDataService } from './BaseDataService';
import { UserRawScore, User, SurveyVersion, SurveyInstance } from '../../models';
import { NotificationService } from '../../services';
import { OpenBlobFile } from '../../utilities';

export class UserRawScoreDataService extends BaseDataService<UserRawScore> {
    constructor(notificationService: NotificationService) {
        super('UserRawScore', 'UserRawScores', notificationService);
    }

    public getStructure(surveyVersion: SurveyVersion): Promise<UserRawScore[]> {
        const endpoint = `${this.endpointRoot}/structure/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getBySurveyVersion(user: User, surveyVersion: SurveyVersion): Promise<UserRawScore[]> {
        const endpoint = `${this.endpointRoot}/${user.id}/bysurveyversion/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getBySurveyInstance(user: User, surveyInstance: SurveyInstance, surveyVersionId?: number): Promise<UserRawScore[]> {
        var endpoint = `${this.endpointRoot}/${user.id}/bysurveyinstance/${surveyInstance.id}`;
        if (surveyVersionId) {
            endpoint = `${endpoint}/${surveyVersionId}`;
        }
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public save(user: User, surveyVersion: SurveyVersion, userRawScores: UserRawScore[]): Promise<any> {
        const endpoint = `${this.endpointRoot}/${user.id}/update/${surveyVersion.id}`;
        const init = this.buildRequestInit('POST', {
            userRawScores: userRawScores
        });

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addInfo('Saved user raw scores');
                return response.json();
            }
            const message = `Error retrieving saving user raw scores.`;
            this.notificationService.addError(message);
            throw new Error('Network response was not ok.');
        });
    }

    public export(user: User, surveyVersion: SurveyVersion, downloadName: string) {
        const endpoint = `${this.endpointRoot}/${user.id}/csv/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyAssessmentViewModel
            if (response.ok) {
                return response.blob();
            }
            const message = `Error retrieving survey responses.`;
            this.notificationService.addError(message);
            throw new Error(message);
        }).then((blobData: any) => {
            return OpenBlobFile(blobData, downloadName + '.csv');
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/UserRawScoreData.tsx